export type BannerType = 'info' | 'success' | 'warning' | 'error'

export interface Announcement {
  id: string
  code: string
  message: string
  bannerType: BannerType
  tenantCode: string | null
  startDate: string
  endDate: string
  isActive: boolean
  displayOrder: number
}

export interface CreateAnnouncementRequest {
  code: string
  message: string
  bannerType: BannerType
  tenantCode: string | null
  startDate: string
  endDate: string
  isActive: boolean
  displayOrder: number
}

export interface UpdateAnnouncementRequest {
  code: string
  message: string
  bannerType: BannerType
  tenantCode: string | null
  startDate: string
  endDate: string
  isActive: boolean
  displayOrder: number
}

export interface ListAnnouncementsResponse {
  data: Announcement[]
}

export const bannerTypeLabels: Record<BannerType, string> = {
  info: 'Info',
  success: 'Success',
  warning: 'Warning',
  error: 'Error'
}
